import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/features/auth/AuthContext";
import { formatApiError } from "@/features/auth/formatError";
import { ROUTES } from "@/constants/routes";

/** Handles `#session_id=...` after Emergent-managed Google sign-in. */
export default function GoogleAuthCallback() {
    const location = useLocation();
    const navigate = useNavigate();
    const { loginWithGoogle } = useAuth();
    const processed = useRef(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;
        const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
        const target = location.pathname || ROUTES.home;
        if (!sessionId) {
            navigate(ROUTES.login, { replace: true });
            return;
        }
        loginWithGoogle(sessionId)
            .then((u) => {
                toast.success(`Welcome, ${u.full_name.split(" ")[0] || "friend"}!`);
                navigate(target, { replace: true });
            })
            .catch((err) => {
                toast.error(formatApiError(err, "Google sign-in failed"));
                navigate(ROUTES.login, { replace: true });
            });
    }, [location.hash, location.pathname, loginWithGoogle, navigate]);

    return (
        <div data-testid="google-auth-callback" className="grid min-h-screen place-items-center text-sm text-muted-foreground">
            Signing you in…
        </div>
    );
}
